<template>
  <v-chip small :color="percentageChipColor" text-color="white">
    <slot name="before-percentage"></slot>
    {{ value }} %
    <slot name="after-percentage"></slot>
  </v-chip>
</template>

<script>
const redToGreenGradient = [
  "#f44336",
  "#ed5127",
  "#e55e17",
  "#dc6900",
  "#d27300",
  "#c77c00",
  "#bc8500",
  "#b08c00",
  "#a49300",
  "#979900",
  "#8a9e04",
  "#7ca31e",
  "#6ea830",
  "#5eab40",
  "#4caf50",
];

export default {
  name: "PercentageChip",
  props: {
    value: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({}),
  computed: {
    percentageChipColor() {
      if (typeof this.value === 'undefined' || this.value === null) {
        return "grey";
      }

      var pct = this.value;
      var div = 100 / (redToGreenGradient.length - 1);
      var slot = Math.floor(pct / div);
      return redToGreenGradient[slot];
    },
  },
};
</script>
